import React from 'react'
import DatauserLogin from '../../Components/PageComponents/UserLogin/DatauserLogin'
import FooterComp from '../../Components/FooterComp/FooterComp'
import HeaderSec from '../../Components/HeaderSec/HeaderSec'

const DataUserLoginPage= () => {
  return (
    <div className=' overflow-hidden'>
        <HeaderSec theme={"light"} />
          <DatauserLogin/>
        <FooterComp  />
    </div>
  )
}

export default DataUserLoginPage
